import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { useParams } from 'react-router-dom'

import { getRFPUrl } from '../helper'
import { 
  MainBodyContent, 
} from 'components'

const RfpDetail = props => {

  let { id } = useParams();
  const { user } = props

  React.useEffect(()=>{
    if(user.username){
      window.location.replace(getRFPUrl(user,id))
    }
  },[user.username])

  return (
    <MainBodyContent headerTitle="Request for Proposal">
      <br/>
      <div style={{display:'flex',justifyContent:'center'}}>
        {user.username?
        <Button size='massive' color='#c5b7a1' style={{width:'50%', alignSelf:'center'}} onClick={()=>window.location.replace(getRFPUrl(user,id))}>Go To Request for Proposal Detail</Button>
        :null}
      </div>
    </MainBodyContent>
  )

}

const mapStateToProps = (state) => ({
  user: state.authen.user
})
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RfpDetail)
